import { getThresholdSchema } from './thresholdSchema';

export const getSchema = (variables = []) => ({
  type: 'object',
  properties: {
    label: {
      type: 'string',
      title: 'Label',
    },
    ...getThresholdSchema(variables),
  },
});

export const schema = getSchema();

export const uiSchema = {};
